import css from "./insights.less";
import React from "react";
import cn from 'classnames'
import type {ClassValue} from '../../helpers/react-helpers'

export interface InsightData {
    gross: string
    confirmed: string
    quotes: string
    deleted: string
    paidSubs?: string
    activeUsers?: string
}

export default function InsightsTotalsRow(data: InsightData) {
    return (
        <div className={css.totalsRow}>
            <Box number={data.deleted} text="Cancelled" color="var(--clr-vib-status-cancelled)"/>
            <Box number={data.quotes} text="Quotes" color="var(--clr-vib-status-quote)"/>
            <Box number={data.confirmed} text="Confirmed" color="var(--clr-vib-status-confirmed)"/>
            <Box number={data.gross} text="Gross" color="var(--clr-bg-blue)"/>
            {data.paidSubs != null ? <Box number={data.paidSubs} className="super-user-only" text="Paid Subs" color="var(--clr-vib-status-confirmed)"/> : null}
            {data.activeUsers != null ? <Box number={data.activeUsers} className="super-user-only" text="Active Users" color="var(--clr-bg-blue)"/> : null}
        </div>
    )
}

interface BoxProps {
    number?: number | string
    text: string
    color: string
    className?: ClassValue
}


function Box({
                 number,
                 text,
                 color,
    className,
             }: BoxProps) {
    return <div className={cn(css.totalsItem,className)} style={{backgroundColor: color}}>
        <div className={css.totalsNumber}>{number === undefined ? '?' : number}</div>
        <div className={css.totalsText}>{text}</div>
    </div>
}
